import { conditionLabel } from '../lib/format'

export function StatusPill({ value, compact = false }: { value: string; compact?: boolean }) {
  const tone = value === 'healthy' || value === 'alive' || value === 'active' || value === 'verified' || value === 'complete' || value === 'closed'
    ? 'positive'
    : value === 'critical' || value === 'dead' || value === 'urgent' || value === 'rejected'
      ? 'danger'
      : value === 'needs_care' || value === 'watch' || value === 'high' || value === 'overdue' || value === 'evidence_submitted'
        ? 'warning'
        : 'neutral'

  return <span className={`status-pill status-pill--${tone} ${compact ? 'is-compact' : ''}`}>{conditionLabel(value)}</span>
}
